import type { ColumnsType } from 'antd/lib/table'
import { CustomHeaderText } from 'src/components'

const carPreviewListColumns: ColumnsType<any> = [
  {
    title: () => <CustomHeaderText text={'admin.MassiveCalculate.tables.Cars.Country'} />,
    dataIndex: 'country',
    render: (_, record) => {
      return (
        <div style={{ marginTop: '10px' }}>
          <span style={{ textAlign: 'center' }}>
            {record.country}
          </span>
        </div>
      )
    },
  },
  {
    title: () => <CustomHeaderText text={'admin.MassiveCalculate.tables.Cars.DistanceKM'} />,
    dataIndex: 'distanceKlm',
    render: (_, record) => {
      return (
        <div style={{ marginTop: '10px' }}>
          <span style={{ textAlign: 'center' }}>
            {record.distanceKlm}
          </span>
        </div>
      )
    },
  },
  {
    title: () => <CustomHeaderText text={'admin.MassiveCalculate.tables.Cars.VehicleModel'} isCentered />,
    dataIndex: 'vehicleModel',
    render: (_, record) => {
      return (
        <div style={{ marginTop: '10px' }}>
          <span style={{ textAlign: 'center' }}>
            {record.vehicleModel}
          </span>
        </div>
      )
    },
  },
  {
    title: () => <CustomHeaderText text={'admin.MassiveCalculate.tables.Cars.VehicleFuel'} isCentered />,
    dataIndex: 'vehiclefuel',
    render: (_, record) => {
      return (
        <div style={{ marginTop: '10px' }}>
          <span style={{ textAlign: 'center' }}>
            {record.vehiclefuel}
          </span>
        </div>
      )
    },
  },
]

export default carPreviewListColumns
